export default __webpack_public_path__ + "static/media/more-vertical.4cad7095.svg";